import React from 'react';
import { useStyletron } from 'baseui';
import type { VisibilityMode } from '../../../labelling-v2/components/stage-scope/types/stage-atoms';
import { VISIBILITY_MODE } from '../../../labelling-v2/components/stage-scope/types/stage-atoms';
import type { StageAnnotation } from '../../providers/stage-provider/types';
export const NON_SELECTED_ANNOTATION_OPACITY = 0.65;
type AnnotationVisibilityWrapperProps = {
  isSelected: boolean;
  isHidden: boolean;
  isRelated: boolean;
  isHovered: boolean;
  isM4VisibilityActive: boolean;
  hasSelection: boolean;
  visibilityMode: VisibilityMode | undefined;
  annotation: StageAnnotation | undefined;
  children: React.ReactNode;
};
export function AnnotationVisibilityWrapper({
  isSelected,
  isHidden,
  isRelated,
  isHovered,
  isM4VisibilityActive,
  hasSelection,
  visibilityMode,
  annotation,
  children
}: AnnotationVisibilityWrapperProps) {
  const [css] = useStyletron();
  if (isHidden) return null;
  const mode = visibilityMode?.type ?? VISIBILITY_MODE.DEFAULT;
  const annotationLabel = annotation?.annotationLabel?.title;
  const isNonFocusedAnnotation = hasSelection && !isSelected && !isRelated && !isHovered;
  if (isM4VisibilityActive) {
    if (mode === VISIBILITY_MODE.SELECTED_ONLY && isNonFocusedAnnotation) {
      return null;
    }
    if (mode === VISIBILITY_MODE.LABEL_ONLY && visibilityMode?.type === VISIBILITY_MODE.LABEL_ONLY && annotationLabel !== visibilityMode?.label) {
      return null;
    }
  }
  const opacity = (() => {
    if (!isM4VisibilityActive || mode === VISIBILITY_MODE.DEFAULT || mode === VISIBILITY_MODE.LABEL_ONLY || !hasSelection) {
      return 1;
    }
    return isSelected ? 1 : NON_SELECTED_ANNOTATION_OPACITY;
  })();
  return <g opacity={opacity} className={css({
    animationName: {
      from: {
        opacity: 0
      },
      to: {
        opacity: opacity
      }
    },
    animationDuration: '0.3s'
  })}>
      {children}
    </g>;
}